import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: nilsfast
 * id 9A7A9F69-9BC4-4619-981D-DF8423A22FF2
 * name table-furniture
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-furniture.svg
 * tags
 * - Home Automation 
 */
export const TableFurnitureIcon = createSvgIcon(<><path d="M2 7H22V10H20L21 19H18.5L17.94 14H6.06L5.5 19H3L4 10H2V7M17.5 10H6.5L6.29 12H17.71L17.5 10Z" /></>, 'TableFurnitureIcon');
export default TableFurnitureIcon